import { useEffect, useState } from "react"

const MS_IN_SECOND = 1000
const MS_IN_MINUTE = 60 * MS_IN_SECOND
const MS_IN_HOUR = 60 * MS_IN_MINUTE
const MS_IN_DAY = 24 * MS_IN_HOUR

const EXPIRED_COUNTDOWN: Countdown = { distance: 0, timeLeft: { hours: 0, minutes: 0, seconds: 0 }, formatted: "00:00" }
const formatTime = (value: number) => value.toString().padStart(2, "0")

const getCountdown = (targetDate: Date): Countdown => {
  const now = new Date().getTime()
  const distance = targetDate.getTime() - now
  const days = Math.floor(distance / MS_IN_DAY)
  const hours = Math.floor((distance % MS_IN_DAY) / MS_IN_HOUR)
  const minutes = Math.floor((distance % MS_IN_HOUR) / MS_IN_MINUTE)
  const seconds = Math.floor((distance % MS_IN_MINUTE) / MS_IN_SECOND)
  const timeLeft = { hours, minutes, seconds }
  let formatted = `${formatTime(timeLeft.minutes)}:${formatTime(timeLeft.seconds)}`
  if (hours > 0) formatted = `${formatTime(hours)}:${formatted}`
  if (days > 0) formatted = `${days}d ${formatted}`
  return distance > 0 ? { distance, timeLeft, formatted } : EXPIRED_COUNTDOWN
}

export const useCountdown = (targetDate: Date): Countdown => {
  const [countdown, setCountdown] = useState<Countdown>(getCountdown(targetDate))

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(getCountdown(targetDate))
    }, 1000)

    return () => clearInterval(interval)
  }, [targetDate])

  return countdown
}

type TimeLeft = {
  hours: number
  minutes: number
  seconds: number
}

type Countdown = {
  distance: number
  timeLeft: TimeLeft
  formatted: string
}
